window.contactData = {}
window.stateIds = {
    'US-AK': 'Alaska',
    'US-AL': 'Alabama',
    'US-AR': 'Arkansas',
    'US-AZ': 'Arizona',
    'US-CA-N': 'California_North',
    'US-CA-S': 'California_South',
    'US-CO': 'Colorado',
    'US-CT': 'Connecticut',
    'US-DE': 'Delaware',
    'US-FL': 'Florida',
    'US-GA': 'Georgia',
    'US-HI': 'Hawaii',
    'US-IA': 'Iowa',
    'US-ID': 'Idaho',
    'US-IL': 'Illinois',
    'US-IN': 'Indiana',
    'US-KS': 'Kansas',
    'US-KY': 'Kentucky',
    'US-LA': 'Louisiana',
    'US-MA': 'Massachusetts',
    'US-MD': 'Maryland',
    'US-ME': 'Maine',
    'US-MI': 'Michigan',
    'US-MN': 'Minnesota',
    'US-MO-E': 'Missouri_East',
    'US-MO-W': 'Missouri_West',
    'US-MS': 'Mississippi',
    'US-MT': 'Montana',
    'US-NC': 'North_Carolina',
    'US-ND': 'North_Dakota',
    'US-NE': 'Nebraska',
    'US-NH': 'New_Hampshire',
    'US-NJ': 'New_Jersey',
    'US-NM': 'New_Mexico',
    'US-NV': 'Nevada',
    'US-NY': 'New_York',
    'US-OH': 'Ohio',
    'US-OK': 'Oklahoma',
    'US-OR': 'Oregon',
    'US-PA-W': 'Pennsylvania_West',
    'US-PA-E': 'Pennsylvania_East',
    'US-RI': 'Rhode_Island',
    'US-SC': 'South_Carolina',
    'US-SD': 'South_Dakota',
    'US-TN': 'Tennessee',
    'US-TX-N': 'Texas_North',
    'US-TX-S': 'Texas_South',
    'US-UT': 'Utah',
    'US-VA': 'Virginia',
    'US-VT': 'Vermont',
    'US-WA': 'Washington',
    'US-WI': 'Wisconsin',
    'US-WV': 'West_Virginia',
    'US-WY': 'Wyoming',
    # Canada
    'CA-NS': 'Nova_Scotia',
    'CA-PE': 'Prince_Edward_Island',
    'CA-NB': 'New_Brunswick',
    'CA-ON': 'Ontario',
    'CA-QC': 'Quebec',
    'CA-MB': 'Manitoba',
    'CA-BC': 'British_Columbia',
    'CA-SK': 'Saskatchewan',
    'CA-AB': 'Alberta',
    'CA-NL': 'Newfoundland_and_Labrador',
    'CA-YT': 'Yukon',
    'CA-NT': 'Northwest_Territories',
    'CA-NU': 'Nunavut',
}

window.contactSiteHandler = ->
    window.addEventListener('load', ->
        bindContactEvents()
        getContactData()
        bindMapEvents()
        bindMobileEvents()
    )

    bindContactEvents = ->
        # Set dropdown list view options
        $('.spaceselect .select2').select2({
            minimumResultsForSearch: Infinity,
            width: 270
        })

    # Choose region
    $('select[name=region]').on('change', ->
        if (this.value)
            return this.form.submit()
    )

    getContactData = ->
        $.ajax(
            type: 'GET',
            url: 'contact-map/',
            success: (data) ->
                usaData = data['USA']
                canadaData = data['Canada']
                combinedData = Object.assign({}, usaData, canadaData)
                window.contactData = combinedData
            error: (data) ->
                return console.log('failure ' + data)
            headers:
                'X-CSRFToken':
                    getCookie('csrftoken')
        )

    bindMapEvents = ->
        map = $('.jsContactMap')
        state = map.find('#map').children()
        modal = $('.jsContactModal')

        $(state).on('click', (e) ->
            e.stopPropagation()
            element = $(e.target)
            allElements = element.siblings()
            allElements.removeClass('active')
            modal.find('.jsContactBox').remove()
            mapOffset = $('.jsContactMap')[0].getBoundingClientRect()
            pathOffset = $(e.target)[0].getBoundingClientRect()
            left = pathOffset.left - mapOffset.left
            top = pathOffset.top - mapOffset.top
            positionX = left - (modal.innerWidth() / 2) + (element[0].getBoundingClientRect().width / 2)

            # Fit modal position to container
            if positionX < 0
                positionX = 0
            else if positionX + modal.innerWidth() > $('.jsContactMap').innerWidth()
                positionX = $('.jsContactMap').innerWidth() - modal.innerWidth()

            # Set modal position
            modal.css({
                'left':positionX,
                'top': top + modal.innerHeight() + (element[0].getBoundingClientRect().height / 2 ) + 60,
            })

            clickedStateId = $(this).attr('id')

            # Add select do state
            element.addClass('active');
            $('.jsContactCloseModal').siblings('.jsContactBox').remove()

            # Set content to modal
            $('.jsContactBoxDivision').text(window.stateIds[clickedStateId].replaceAll('_', ' '))

            # For each contact in state
            for key in Object.keys(window.contactData)
                convertedKey = key.replaceAll('_', '').replaceAll(' ', '')
                convertedClickedStateId = window.stateIds[clickedStateId].replaceAll('_', '')

                if convertedKey == convertedClickedStateId
                    i = 0
                    while i < window.contactData[key].length
                        # Each person data
                        stateContactPerson = window.contactData[key][i]

                        # Person template
                        contactTemplate = '' +
                            '<div class="contact-box jsContactBox">' +
                            '<div class="contact-box__image">' +
                            '<img src="' + stateContactPerson['image'] + '" alt="" class="jsContactBoxImg">' +
                            '</div>' +
                            '<div class="contact-box__content">' +
                            '<div class="contact-box__content__name jsContactBoxName">' +
                            stateContactPerson['first_name'] + ' ' + stateContactPerson['last_name'] +
                            '</div>' +
                            '<div class="contact-box__content__position jsContactBoxPosition">' +
                            stateContactPerson['job_title'] +
                            '</div>' +
                            '<a class="contact-box__content__number jsContactBoxNumber" href="tel:' + stateContactPerson['phone_number'] + '">' +
                            stateContactPerson['phone_number'] +
                            '</a>' +
                            '<a class="contact-box__content__mail jsContactBoxMail" href="mailto:' + stateContactPerson['email'] + '">' +
                            stateContactPerson['email'] +
                            '</a>' +
                            '</div>' +
                            '</div>'
                        $(contactTemplate).insertBefore('.jsContactBoxBar')
                        i++

            # Open modal if exist contacts
            if modal.find('.jsContactBox').length > 0
                modal.fadeIn().addClass('active')
            else
                modal.hide()
        )

        # Close modal - click on "x"
        $('.jsContactCloseModal').on('click', (e) ->
            e.stopPropagation()
            $('.jsContactCloseModal').parent().fadeOut().removeClass('active')
            state.removeClass('active')
        )

    bindMobileEvents = ->
        itemTitle = $('.jsContactListItemTitle')
        itemContent = '.jsContactListItemContent'

        itemTitle.each(->
            # Show chose state
            $(this).on('click', ->
                clickedItemContent = $(this).siblings(itemContent)
                if clickedItemContent.css('display') != 'block'
                    itemTitle.siblings(itemContent).slideUp()

                    # Show contact and add content
                    clickedItemContent.slideDown()
            )
        )
